import React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import { SCard } from 'common/modules/printing/styles/Card';
import IntervalGraph from 'common/components/charts/IntervalGraph';
import Radio from 'common/domain/radio';

import type { ReachState } from '../domain/State';
import ReachDateRangeMetrics from '../components/ReachDateRangeMetrics';
import { ErrorWrapper, GraphWrapper } from '../components/styles';
import MetricsPrintingHeader from './MetricsPrintingHeader';
import MetricsPrintingParametersCard from './MetricsPrintingParametersCard';

const ContentWrapper = styled.div`
  padding: 3px;
  background-color: white;
  box-sizing: border-box;

  width: 8.5in;
  height: 11in;
  font-size: 12px;

  @page {
    size: letter portrait;
    margin: 2.00cm 0 2.00cm 0;
  }
`;

type Props = {
  reach: ReachState;
  radio: Radio;

  t: any;
  theme: any;
}

const ReachPrinting = (props: Props) => {
  const {
    dateRange,
    dateRangeCompared,
    totalReach,
    averageTotalReach,
    averageQuarterHourReach,
    interval,
    reachByInterval,
    days,
    centralMarket,
  } = props.reach;
  const { theme, t, radio } = props;

  return (
    <ContentWrapper>
      <MetricsPrintingHeader title={t('reach').toUpperCase()} radio={radio} centralMarket={centralMarket} />
      <MetricsPrintingParametersCard dateRange={dateRange} dateRangeCompared={dateRangeCompared} interval={interval} days={days} />
      <SCard>
        <ReachDateRangeMetrics
          smaller
          dateRange={dateRange}
          totalCumulative={totalReach.data}
          totalAverageReach={averageTotalReach.data}
          averageQuarterHour={averageQuarterHourReach.data}
        />
      </SCard>
      {dateRangeCompared &&
        <SCard>
          <ReachDateRangeMetrics
            smaller
            dateRange={dateRangeCompared}
            totalCumulative={totalReach.data.compared}
            totalAverageReach={averageTotalReach.data.compared}
            averageQuarterHour={averageQuarterHourReach.data.compared}
          />
        </SCard>
      }
      <SCard>
        {reachByInterval.error &&
          <ErrorWrapper style={theme.fonts.style.cardTitle}>{t('noDataAvailable')}</ErrorWrapper>
        }
        {!reachByInterval.error &&
          <GraphWrapper>
            <IntervalGraph
              metricName={t('reach')}
              data={reachByInterval.data || {}}
              isCompared={Boolean(dateRangeCompared)}
              fromTime={interval.from}
              toTime={interval.to}
              disableAnimations
              displayHorizontalLines
              hideBrush
            />
          </GraphWrapper>
        }
      </SCard>
    </ContentWrapper>
  );
};

export default translate('metrics')(withTheme(ReachPrinting));



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/printing/ReachPrinting.js